import { inject, injectable } from "inversify";
import { ActivitySummary } from "@project/domain/models/activity-summary.model";
import { ActivityDatasource } from "../datasource/activity.datasource";

@injectable()
export class ActivityRepository {
    constructor(
        @inject(ActivityDatasource)
        private readonly activityDatasource: ActivityDatasource,
    ) { }

    async getByIds(ids: number[]): Promise<ActivitySummary[]> {
        try {
            const response = await this.activityDatasource.fetchByIds(ids);

            return response.fold(
                // Handle error case (Left)
                (error) => {
                    console.error("Error al obtener actividades por IDs:", error);
                    return [];
                },
                // Handle success case (Right)
                (activities) => activities
            );
        } catch (error) {
            console.error("Error inesperado al obtener actividades por IDs:", error);
            return [];
        }
    }
}